import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Chip from '@material-ui/core/Chip';
import Avatar from '@material-ui/core/Avatar';
import Tooltip from '@material-ui/core/Tooltip';
import MenuIcon from '@material-ui/icons/Menu';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

type Props = {
  title: string;
  env: string; // XROSS_ENV を渡す
  user?: {
    displayName?: string | null;
    email?: string | null;
    photoUrl?: string | null;
  };
  drawerOpen: boolean;
  onOpenDrawer: () => void;
  onAvatarClick: () => void;
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    appBar: {
      zIndex: theme.zIndex.drawer + 1,
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
    },
    menuButton: {
      marginRight: theme.spacing(3),
    },
    title: {
      fontWeight: 700,
      letterSpacing: 0.2,
      marginRight: theme.spacing(1.5),
    },
    grow: {
      flexGrow: 1,
    },
    envChip: {
      fontWeight: 700,
      height: 24,
    },
    userName: {
      ...theme.typography.body2,
      marginRight: theme.spacing(1),
      color: theme.palette.common.white,
      opacity: 0.85,
      [theme.breakpoints.down('xs')]: {
        display: 'none',
      },
    },
    avatar: {
      width: 32,
      height: 32,
      border: '2px solid rgba(255,255,255,.35)',
    },
  })
);

// envごとの配色（見やすく強いコントラスト）
const envStyle = (env: string) => {
  switch (env) {
    case 'production':
    case 'live':
      return { bg: '#D32F2F', color: '#fff', label: '本番環境' }; // 赤
    case 'staging':
      return { bg: '#FFB300', color: '#111', label: 'ステージング' }; // 橙
    case 'dev':
    case 'development':
    default:
      return { bg: '#FFEE58', color: '#111', label: '開発環境' }; // 黄
  }
};

export const AdminAppBar: React.FC<Props> = ({
  title,
  env,
  user,
  drawerOpen,
  onOpenDrawer,
  onAvatarClick,
}) => {
  const classes = useStyles();
  const es = envStyle(env);

  return (
    <AppBar position="absolute" className={classes.appBar}>
      <Toolbar>
        {/* 左：メニューボタン */}
        <IconButton
          edge="start"
          color="inherit"
          aria-label="open drawer"
          onClick={onOpenDrawer}
          className={classes.menuButton}
        >
          <MenuIcon />
        </IconButton>

        {/* タイトル + 環境バッジ */}
        <Typography variant="h6" noWrap className={classes.title}>
          xross.club 運用管理（Moon）
        </Typography>
        <Chip
          className={classes.envChip}
          label={es.label}
          style={{ backgroundColor: es.bg, color: es.color }}
          size="small"
        />

        {/* 伸縮スペーサ */}
        <div className={classes.grow} />

        {/* 右：ユーザ情報 */}
        <span className={classes.userName}>
          {user?.displayName || ''}
          {user?.email ? `（${user.email}）` : ''}
        </span>
        <Tooltip title="アカウント / ログアウト">
          <IconButton color="inherit" onClick={onAvatarClick}>
            <Avatar
              src={user?.photoUrl || undefined}
              className={classes.avatar}
            />
          </IconButton>
        </Tooltip>
      </Toolbar>
    </AppBar>
  );
};
